import TimeStamp from "../timeStamp";

export class SportJahr {
    constructor(user){
        this.current = this.getCurrentSportJahr( TimeStamp.getTodayString() );
        this.abmeldung = this.getAbmeldungSportJahr( TimeStamp.getTodayString() );
        this.previous = this.getCurrentSportJahr( this.getNextOrPreviousYear(-1) );
        this.next = this.getCurrentSportJahr( this.getNextOrPreviousYear(1) );
        this.ummeldung = this.getUmmeldungSportJahr(user);
        this.adminList = this.getAdminList();
        this.adminListFull = this.getAdminListFull();
        this.anmeldeList = this.getAnmeldeList();
        this.verlaengerung = this.getSportJahrForVerlaengerung();
    }

    getObjectFromSportJahrValue(sportJahrValue){
        if ( !sportJahrValue  ) { return {} }
        let years = sportJahrValue.split('_');
        return {
            id: sportJahrValue,
            value: sportJahrValue,
            text: years[0] + '/' + years[1],
            from: years[0] + '-07-01',
            until: years[1] + '-06-30',
        }
    }

    getCurrentSportJahr(dateText){
        let dateParts = dateText.split('-');
        let year = parseInt(dateParts[0]);
        let startYear = parseInt(dateParts[1]) >= 7 ? year : year - 1;
        let endYear = startYear + 1;
        return {
            id: startYear + '_' + endYear,
            value: startYear + '_' + endYear,
            text: startYear + '/' + endYear,
            from: startYear + '-07-01',
            until: endYear + '-06-30',
        }
    }

    getSportJahrFromDate(dateText){
        let dateParts = dateText.split('-');
        let year = parseInt(dateParts[0]);
        let startYear = parseInt(dateParts[1]) >= 7 ? year : year - 1;
        let endYear = startYear + 1;
        return {
            id: startYear + '_' + endYear,
            value: startYear + '_' + endYear,
            text: startYear + '/' + endYear,
            from: startYear + '-07-01',
            until: endYear + '-06-30',
        }
    }

    getAbmeldungSportJahr(dateText){
        let dateParts = dateText.split('-');
        let year = parseInt(dateParts[0]);
        let startYear = parseInt(dateParts[1]) > 7 ? year : year - 1;
        let endYear = startYear + 1;
        return {
            id: startYear + '_' + endYear,
            value: startYear + '_' + endYear,
            text: startYear + '/' + endYear,
            from: startYear + '-07-01',
            until: endYear + '-06-30',
        }
    }

    getNextOrPreviousYear(increment){
        let dateText = TimeStamp.getTodayString();
        let dateParts = dateText.split('-');
        dateParts[0] = parseInt(dateParts[0]) + increment;
        return dateParts.join('-');
    }

    getUmmeldungSportJahr(user){
        let dateText = TimeStamp.getTodayString();
        let dateParts = dateText.split('-');
        let month = parseInt(dateParts[1]);
        let ummeldeJahr, yearBefore;
        if ( user?.permissions.pass ) {
            ummeldeJahr = month < 7 ? this.next :
                month === 7 || month === 8 || month === 9 ||
                month === 10 || month === 11 || month === 12 ? this.current : null;
            yearBefore = month < 7 ? this.current :
                month === 7 || month === 8 || month === 9 ||
                month === 10 || month === 11 || month === 12 ? this.previous : null;
        } else {
            ummeldeJahr = month < 7 ? this.next :
                month === 7 || month === 8 ? this.current : null;
            yearBefore = month < 7 ? this.current :
                month === 7 || month === 8 ? this.previous : null;
        }
        return {ummeldeJahr: ummeldeJahr, yearBefore: yearBefore}
    }

    getAdminList(){
        let dateText = TimeStamp.getTodayString();
        let dateParts = dateText.split('-');
        return parseInt(dateParts[1]) < 7 ?
            [this.previous, this.current, this.next] : [this.previous, this.current]
    }

    getAdminListFull(){
        const sportJahrList = this.getAdminList()
        let before = { id: '' }
        let i = -2
        do {
            before = this.getCurrentSportJahr( this.getNextOrPreviousYear(i) );
            sportJahrList.unshift(before)
            i--
        } while (before.id !== '2021_2022');
        return sportJahrList
    }

    getAnmeldeList(){
        let dateText = TimeStamp.getTodayString();
        let dateParts = dateText.split('-');
        return parseInt(dateParts[1]) < 7 ?
            [this.current, this.next] : [this.current]
    }
    getVerlaengerungStatus(spieler){
        const lastSportTag = spieler.dates.lastSportTag;
        const dateText = TimeStamp.getTodayString();
        const dateParts = dateText.split('-');
        const currentYear = parseInt(dateParts[0]);
        const currentMonth = parseInt(dateParts[1]);
        const lastSportTagParts = lastSportTag.split('-');
        const lastSportTagYear = parseInt(lastSportTagParts[0]);
        if ( currentYear < lastSportTagYear || currentYear - lastSportTagYear > 1) { return ''; }
        if ( currentYear === lastSportTagYear) {
            if ( currentMonth < 7 ) { return 'warning'; }
            return 'error';
        }
        // Folgendes gilt demnach für currentYear - lastSportTagYear === -1 also 2022 vs 2021
        /*if ( currentMonth > 8 ) { return ''; }
        if ( currentMonth === 8 ) { return 'error'; }*/
        if ( currentMonth <= 7 ) { return 'error'; }
        return '';
    }
    getSportJahrForVerlaengerung(){
        let dateText = TimeStamp.getTodayString();
        let dateParts = dateText.split('-');
        return parseInt(dateParts[1]) < 7 ? [this.current, this.next] : [this.current]
    }

}